import { render } from "./DataFreshnessChip.vue?vue&type=template&id=1741bd53&scoped=true"
import script from "./DataFreshnessChip.vue?vue&type=script&lang=js"
export * from "./DataFreshnessChip.vue?vue&type=script&lang=js"

import "./DataFreshnessChip.vue?vue&type=style&index=0&id=1741bd53&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1741bd53"]])

export default __exports__